<template>
  <div>
    <section class="hero is-grey-ligth mainContent">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column">
              <h1 class="title has-text-dark">Informes</h1>
              <h2 class="subtitle has-text-dark">Lista</h2>
            </div>
          </div>
          <!-- <div class="columns">
            <div class="column">
              <div class="buttons">
                <button
                  v-for="(item, index) in carpetas"
                  :key="index"
                  class="button is-info is-inverted is-medium"
                  @click="selectfolder(item)"
                  v-bind:class="{ 'is-outlined': folderselect(item) }"
                >
                  <span class="icon">
                    <i v-show="folderselect(item)" class="material-icons">folder</i>
                    <i v-show="!folderselect(item)" class="material-icons">folder_open</i>
                  </span>
                  <span>{{item.nombre}}</span>
                </button>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </section>
    <section class="section mainContent">
      <div class="tabs topSubMenu">
        <ul class="selectedMenu">
          <router-link custom v-slot="{ navigate }" :to="{ name: 'listview' }">
            <li @click="navigate" @keypress.enter="navigate" role="link">
              <a>Ver informes</a>
            </li>
          </router-link>
        </ul>
        <ul>
          <router-link
            custom
            v-slot="{ navigate }"
            :to="{ name: 'listview.crea' }"
          >
            <li @click="navigate" @keypress.enter="navigate" role="link">
              <a>Crear informe</a>
            </li>
          </router-link>
        </ul>
        <ul>
          <router-link
            custom
            v-slot="{ navigate }"
            :to="{ name: 'listview.carpetaslist' }"
          >
            <li @click="navigate" @keypress.enter="navigate" role="link">
              <a>Editar Informes</a>
            </li>
          </router-link>
        </ul>
        <ul>
          <router-link
            custom
            v-slot="{ navigate }"
            :to="{ name: 'listview.plantillalist' }"
          >
            <li @click="navigate" @keypress.enter="navigate" role="link">
              <a>Plantillas</a>
            </li>
          </router-link>
        </ul>
        <ul>
          <router-link
            custom
            v-slot="{ navigate }"
            :to="{ name: 'listview.guides' }"
          >
            <li @click="navigate" @keypress.enter="navigate" role="link">
              <a>Guías</a>
            </li>
          </router-link>
        </ul>
      </div>
      <div class="container">
        <div class="content">
          <div class="columns" style="margin-top:20px;">
            <div class="column">
              <div class="buttons">
                <button
                  v-for="(item, index) in carpetas"
                  :key="index"
                  class="button is-info is-medium"
                  @click="selectfolder(item)"
                  v-bind:class="{ 'is-outlined': folderselect(item) }"
                >
                  <span class="icon">
                    <i v-show="folderselect(item)" class="material-icons"
                      >folder</i
                    >
                    <i v-show="!folderselect(item)" class="material-icons"
                      >folder_open</i
                    >
                  </span>
                  <span>{{ item.nombre }}</span>
                </button>
              </div>
            </div>
          </div>
          <h1 class="title is-2">{{ carpetaselected.nombre }}</h1>
          <h3 class="subtitle is-4">{{ carpetaselected.descripcion }}</h3>
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Informe</th>
                <th>Controles</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(info, index) in informes" :key="index">
                <td>
                  <span class="subtitle is-3">{{ index + 1 }}</span>
                </td>
                <td>
                  <span class="is-size-3">{{ info.nombre }}</span>
                </td>
                <td>
                  <router-link
                    :to="{ name: 'listviewid', params: { id: info.id } }"
                    class="button is-info"
                  >
                    <span v-tooltip="'Ver Informe'" class="icon">
                      <i class="material-icons">visibility</i>
                    </span>
                  </router-link>
                  <button class="button is-link" @click="showShare(info)">
                    <span v-tooltip="'Link de Informe'" class="icon">
                      <i class="material-icons">share</i>
                    </span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    <modalshare
      :show="showData"
      :informe="infoshare"
      @showmodalshare="showmodalshare"
    ></modalshare>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import modalshare from "@/components/modals/Modalshare.vue";

export default {
  data() {
    return {
      carpetas: [],
      informes: [],
      carpetaselected: {},
      infoshare: {},
      showData: false,
      nombreVariables: {
        apjef: "Jefe",
        claor: "Claridad",
        train: "Trato",
        disre: "Recursos",
        aop: "Apoyo Org.",
        esta: "Estabilidad",
        retri: "Retribución",
        coher: "Coherencia",
        senpe: "Pertenencia",
        tequi: "Equipo",
        cc: "Clima",
        coop: "Cooperación",
        respo: "Responsabilidad",
        respe: "Respeto",
        est: "Estímulo",
        apoy: "Apoyo",
        parti: "Participación",
        ig: "Imagen Gerencial",
        ie: "Imagen Empresa",
        cvrel: "Imagen Relaciones",
        eng: "Engagement",
        cafec: "Compromiso Afectivo",
        ccont: "Compromiso de Continuidad",
        cnorm: "Compromiso Normativo",
        perfil: "Perfil",
        eaptra_a: "Disfrute en el trabajo",
        gratra_a: "Gratificación en el trabajo",
        sentra_a: "Sentido en el trabajo",
        eapvid_a: "Estado Afectivo Positivo en la Vida",
        gravid_a: "Gratificación en la Vida",
        senvid_a: "Sentido en la Vida",
        f_tra_a: "Felicidad en el trabajo",
        f_vid_a: "Felicidad en la Vida",
        vida_a: "",
        eaptra_b: "Disfrute en el trabajo.",
        gratra_b: "Gratificación en el trabajo.",
        sentra_b: "Sentido  en el trabajo.",
        eapvid_b: "Estado Afectivo Positivo en la Vida.",
        gravid_b: "Gratificación en la Vida.",
        senvid_b: "Sentido en la Vida.",
        f_tra_b: "Felicidad en el trabajo.",
        f_vid_b: "Felicidad en la Vida.",
        benef: "Beneficios",
        satis: "Satisfacción",
        demograficos: "Demográficos",
      },
    };
  },
  computed: {
    ...mapState(["idtoken"]),
  },
  methods: {
    showShare(i) {
      this.infoshare = i;
      this.showData = true;
    },
    showmodalshare() {
      if (this.showData) {
        this.showData = false;
      } else {
        this.showData = true;
      }
    },
    folderselect(f) {
      if (f.id === this.carpetaselected.id) {
        return false;
      } else {
        return true;
      }
    },
    selectfolder(f) {
      this.carpetaselected = f;
      this.traeInformes(this, f.id);
    },
    async traeData(_this) {
      try {
        await _this.traeCarpetas(_this);
        if (_this.carpetas.length > 0) {
          const carpeta1 = _this.carpetas[0];
          _this.carpetaselected = carpeta1;
          _this.traeInformes(_this, carpeta1.id);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async traeCarpetas(_this) {
      let result;
      try {
        result = await apiServices.get(`/carpetas`);
        _this.carpetas = [];
        if (result.data.length > 0) {
          result.data.forEach((el) => {
            if (el.nombre !== "DEFAULTSINCLASIFICARSIETE") {
              const d = {
                nombre: el.nombre,
                descripcion: el.descripcion,
                id: el._id,
              };
              _this.carpetas.push(d);
            } else {
              _this.carpetas.push({
                nombre: "Sin Clasificar",
                descripcion: "Informes que no se han asignado a una carpeta",
                id: el._id,
              });
            }
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async traeInformes(_this, idcarpeta) {
      let result;
      try {
        result = await apiServices.get(`/informelist/${idcarpeta}`);
        _this.informes = [];
        result.data.forEach((el) => {
          const d = {
            nombre: el.title,
            id: el._id,
            status: el.status,
            password: el.password,
            informes: el.informes,
          };
          _this.informes.push(d);
        });
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    if (this.idtoken) {
      this.traeData(this);
    }
  },
  watch: {
    idtoken(nv, ov) {
      if (nv) {
        this.traeData(this);
      }
    },
  },
  components: {
    modalshare,
  },
};
</script>
<style lang="scss" scoped>
.mainContent {
  padding: 0px 60px;
}

.topSubMenu {
  padding: 0px 60px;
  margin: 10px 0px 5px 0px;
}

.selectedMenu li a {
  color: #510087;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/informes/Listview.vue